module.exports = __webpack_public_path__ + "static/media/event-management.df0bcdc0.jpg";